export default __webpack_public_path__ + "static/video-icon-210c1071d721c8d778dc6d7fcf495fc9.png";